import React, { useContext, useEffect } from "react";
import NeedCertificateTable from "../../Components/Greenox/NeedCertificateTable/NeedCertificateTable";
import { AppContext } from "../../ContextApi/AppContext/AppContext";

function Energy(props) {
  const { setState, state } = useContext(AppContext);
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      otherData: {
        hotwater_included_in_heating_system: 0,
        construction_year: null,
        heating_info: [],
        yearArray: [],
        buildingData: {},
        buildingData: {},
        vacancy: [],
        noOfHeatingSystem: null,
        property: null,
        delAdd: null,
        info: {},
      },
      needData: {
        heatingSystemsCount: null,
        hotSystemsCount: null,
        construction_year: null,
        floor_details: [],
        roof_detail: {},
        basement_detail: {},
        insulation_details: [],
        windowDimension: false,
        active: {},
        insulation: false,
        heating_systems: [],
        hot_water_systems: [],
        are_renewable_energy_used: false,
        do_u_have_solar_collector: false,
        unobstructed_collector_area: null,
        number_of_air_conditioning_systems: 0,
        cooling_capacity: null,
        next_inspection_date: "",
        address: {
          direction_point: null,
          is_property_have_border_on_another_house: false,
          location: "",
          postcode: "",
          street: "",
        },
        billing_address: {
          order_type: 1,
          first_name: "",
          last_name: "",
          phone: null,
          postcode: null,
          location: "",
          email: "",
          company_name: "",
          vat_id: "",
          street: "",
        },
      },
      page: 1,
      filledPage: 1,
      needId: null,
    }));
  }, []);
  return (
    <div>
      <NeedCertificateTable />
    </div>
  );
}

export default Energy;
